import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Swiper, { Navigation } from 'swiper';
import styles from './index.css';
import { formatImage } from '@ifeng-fe/public_method';
import { getThumbnail } from '@src/common/utils';

Swiper.use([ Navigation ]);

class Matirx extends PureComponent {

    static propTypes = {
        content: PropTypes.array
    }

    componentDidMount() {
        new Swiper('#swiper3', {
            loop: true,
            slidesPerView: 3,
            spaceBetween: 16,
            navigation: {
                prevEl: '.prev3',
                nextEl: '.next3'
            },
        });
    }

    render() {
        const { content } = this.props;

        return (
            <div className={styles.container}>
                <div className={styles.toolbar}>
                    <div className={`${styles.prev3} prev3`} />
                    <div className={`${styles.next3} next3`} />
                </div>
                <div className={styles.swiperWp}>
                    <div className="swiper" id="swiper3">
                        <div className="swiper-wrapper">
                            {
                                content.filter((a, i) => i % 2 === 0).map((data, index) => {
                                    return (
                                        <div className="swiper-slide" key={index}>
                                            <div className={styles.swiperItem}>
                                                <div className={styles.item}>
                                                    <div className={styles.imgWp}>
                                                        <img src={formatImage(getThumbnail(content[2 * index]), 320 * 2, 140 * 2)} alt={content[2 * index].title} />
                                                    </div>
                                                    <div className={styles.title}>{content[2 * index].title}</div>
                                                </div>
                                                {
                                                    content[2 * index + 1] &&
                                                    <div className={styles.item}>
                                                        <div className={styles.imgWp}>
                                                            <img src={formatImage(getThumbnail(content[2 * index + 1]), 320 * 2, 140 * 2)} alt={content[2 * index + 1].title} />
                                                        </div>
                                                        <div className={styles.title}>{content[2 * index + 1].title}</div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Matirx;
